export default __webpack_public_path__ + "static/media/1131.95231f94.png";